import "./loopview.css";
import { IMG_PATH } from "../../server";
import LooptwoImg from "../../Assets/images/loop5Img.svg";

const LoopOnebody = ({ data, setSelectSkill, selectSkill }) => {
  return (
    <div>
      {/* <p className='duration'>{data.Duration}m Duration</p> */}
      <p className="bodytext1">{data.bodytext1}</p>

      {data.video1 ? (
        // <div className="w-full aspect-video mt-4 rounded-md shodowview overflow-hidden">
        //   <video
        //     src={IMG_PATH + data.video1}
        //     controls
        //     className="w-full h-full object-cover"
        //   />
        // </div>
       <div className="mt-4 px-1">
  <div className="w-full aspect-video rounded-md shodowview">
    <div className="overflow-hidden rounded-md">
      <video
        src={IMG_PATH + data.video1}
        controls
        className="w-full h-full object-cover"
      />
    </div>
  </div>
</div>
      ) : (
        <img
          src={LooptwoImg}
          alt="LoopFiveImg"
          className="w-full h-full object-cover"
        />
      )}
    </div>
  );
};

export default LoopOnebody;

{
  /* <div className='skills-container'>
        <span
          onClick={() => setSelectSkill('Writing')}
          className={`${selectSkill === 'Writing' ? 'selectedtag' : 'tag'} btn`}
        >
          Writing
        </span>
        <span
          onClick={() => setSelectSkill('Communication')}
          className={`${
            selectSkill === 'Communication' ? 'selectedtag' : 'tag'
          } btn`}
        >
          Communication
        </span>
      </div> */
}
